import React from "react";
import { useNavigate } from "react-router-dom";

export default function CoinPacksDemoPage() {
  const navigate = useNavigate();

  const packs = [
    { coins: 100, price: "1.00€", badge: "🔥 POPULAIRE" },
    { coins: 200, price: "2.00€" },
    { coins: 300, price: "3.00€" },
    { coins: 500, price: "5.00€" },
    { coins: 1000, price: "10.00€", badge: "✨ MEILLEUR RAPPORT", highlight: true },
    { coins: 1500, price: "15.00€" },
  ];

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes neonTitle {
          0%,100% { text-shadow: 0 0 18px rgba(0,242,255,.8), 0 0 45px rgba(0,242,255,.45); }
          50% { text-shadow: 0 0 30px rgba(0,242,255,1), 0 0 75px rgba(0,242,255,.75); }
        }

        @keyframes cardFloat {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        @keyframes chestMove {
          0%,100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-7px) scale(1.04); }
        }

        @keyframes coinSpark {
          0% { transform: translateY(12px) scale(.5); opacity: 0; }
          40% { opacity: 1; }
          100% { transform: translateY(-30px) scale(1); opacity: 0; }
        }

        @keyframes scan {
          0% { transform: translateX(-140%); opacity: 0; }
          35% { opacity: 1; }
          100% { transform: translateX(140%); opacity: 0; }
        }

        @keyframes ringPulse {
          0%,100% { transform: scale(1); opacity: .55; }
          50% { transform: scale(1.08); opacity: 1; }
        }

        @keyframes percentPulse {
          0%,100% { transform: scale(1); box-shadow: 0 0 22px rgba(0,242,255,.35); }
          50% { transform: scale(1.06); box-shadow: 0 0 55px rgba(0,242,255,.8); }
        }

        @media (max-width: 760px) {
          .packs-grid { grid-template-columns: 1fr !important; }
          .commission-box { grid-template-columns: 1fr !important; text-align: center !important; }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.heroGlow} />

      <h1 style={styles.title}>PACKS DE COINS</h1>
      <p style={styles.subtitle}>Recharge ton solde et soutiens tes créateurs préférés</p>

      <div style={styles.frame}>
        <div style={styles.sideLeft}>‹</div>
        <div style={styles.sideRight}>›</div>

        <div className="packs-grid" style={styles.grid}>
          {packs.map((p, index) => (
            <div
              key={p.coins}
              style={{
                ...styles.card,
                ...(p.highlight ? styles.highlightCard : {}),
                animationDelay: `${index * 0.12}s`,
              }}
            >
              <div style={styles.scanLine} />

              {p.badge && (
                <div style={p.highlight ? styles.badgeCyan : styles.badgeGold}>
                  {p.badge}
                </div>
              )}

              <div style={styles.chestWrap}>
                <div style={styles.sparkOne}>✦</div>
                <div style={styles.sparkTwo}>✦</div>
                <div style={styles.coinOne} />
                <div style={styles.coinTwo} />
                <div style={styles.coinThree} />

                <div style={styles.chest}>
                  <div style={styles.chestLid} />
                  <div style={styles.chestBandLeft} />
                  <div style={styles.chestBandRight} />
                  <div style={styles.chestLockRing} />
                  <div style={styles.chestLock} />
                </div>
              </div>

              <div style={styles.packInfo}>
                <div style={styles.coins}>{p.coins}</div>
                <div style={styles.coinLabel}>coins</div>
                <div style={styles.sep} />
                <div style={styles.price}>{p.price}</div>
              </div>

              <button style={styles.buyBtn}>Acheter</button>
            </div>
          ))}
        </div>
      </div>

      <div className="commission-box" style={styles.commissionBox}>
        <div style={styles.bigShield}>✓</div>

        <div style={styles.commissionTextBox}>
          <h2 style={styles.commissionTitle}>TRANSPARENCE & ÉQUITÉ</h2>
          <p style={styles.commissionText}>
            EVO-LIVE prend seulement <strong style={styles.percentInline}>20%</strong> de commission.
          </p>
          <p style={styles.commissionSub}>
            Comparé à d’autres plateformes, tu gardes plus de tes gains.
            <br />
            <strong style={{ color: "#00f2ff" }}>Ton succès, ta récompense.</strong>
          </p>
        </div>

        <div style={styles.percentCircle}>
          <div style={styles.percentNumber}>20%</div>
          <div style={styles.percentSmall}>SEULEMENT</div>
        </div>
      </div>

      <div style={styles.bottomInfo}>
        <div style={styles.infoItem}>🔒 <strong>Paiements sécurisés</strong><span>Données protégées</span></div>
        <div style={styles.infoItem}>⚡ <strong>Coins crédités instantanément</strong><span>Sans délai</span></div>
        <div style={styles.infoItem}>✅ <strong>Prix réels et clairs</strong><span>Aucun frais caché</span></div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    overflowY: "auto",
    background:
      "radial-gradient(circle at top, rgba(0,242,255,.16), transparent 34%), radial-gradient(circle at bottom, rgba(0,80,130,.18), transparent 35%), #02060c",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "28px 22px 42px",
    textAlign: "center",
    position: "relative",
  },

  back: {
    position: "fixed",
    top: 24,
    left: 24,
    zIndex: 50,
    padding: "12px 26px",
    borderRadius: 22,
    border: "1px solid rgba(0,242,255,.85)",
    background: "rgba(0,14,22,.86)",
    color: "#00f2ff",
    fontSize: 18,
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 22px rgba(0,242,255,.22)",
  },

  heroGlow: {
    position: "absolute",
    top: 35,
    left: "50%",
    width: 520,
    height: 180,
    transform: "translateX(-50%)",
    background: "radial-gradient(circle, rgba(0,242,255,.18), transparent 65%)",
    filter: "blur(10px)",
    pointerEvents: "none",
  },

  title: {
    margin: "18px 0 6px",
    fontSize: "clamp(42px, 5vw, 70px)",
    lineHeight: 1,
    letterSpacing: 2,
    color: "#5ffaff",
    fontWeight: 900,
    textShadow: "0 0 26px rgba(0,242,255,.9)",
    animation: "neonTitle 2.6s infinite",
  },

  subtitle: {
    margin: "0 0 30px",
    color: "rgba(230,250,255,.72)",
    fontSize: "clamp(18px, 2vw, 26px)",
  },

  frame: {
    maxWidth: 1050,
    margin: "0 auto",
    padding: "14px 28px",
    position: "relative",
    borderRadius: 30,
    background:
      "linear-gradient(90deg, rgba(0,242,255,.12), rgba(0,10,18,.18), rgba(0,242,255,.12))",
    boxShadow: "inset 0 0 28px rgba(0,242,255,.14)",
  },

  sideLeft: {
    position: "absolute",
    left: 8,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#5ffaff",
    fontSize: 46,
    textShadow: "0 0 18px rgba(0,242,255,.9)",
  },

  sideRight: {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#5ffaff",
    fontSize: 46,
    textShadow: "0 0 18px rgba(0,242,255,.9)",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(200px, 1fr))",
    gap: 18,
    maxWidth: 880,
    margin: "0 auto",
  },

  card: {
    minHeight: 165,
    borderRadius: 20,
    border: "1px solid rgba(0,242,255,.42)",
    background:
      "linear-gradient(145deg, rgba(0,16,28,.96), rgba(0,6,12,.95))",
    boxShadow: "0 0 22px rgba(0,242,255,.16)",
    padding: "20px 18px 15px",
    position: "relative",
    overflow: "hidden",
    display: "grid",
    gridTemplateColumns: "40% 60%",
    alignItems: "center",
    animation: "cardFloat 3s ease-in-out infinite",
  },

  highlightCard: {
    border: "2px solid rgba(95,250,255,.9)",
    boxShadow: "0 0 32px rgba(0,242,255,.45), inset 0 0 22px rgba(0,242,255,.10)",
  },

  scanLine: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(110deg, transparent 20%, rgba(0,242,255,.12) 48%, transparent 70%)",
    animation: "scan 3.8s infinite",
    pointerEvents: "none",
  },

  badgeGold: {
    position: "absolute",
    top: 0,
    left: 0,
    padding: "5px 12px",
    borderRadius: "0 0 12px 0",
    background: "linear-gradient(90deg, #ffd24a, #ffb000)",
    color: "#3b2100",
    fontWeight: 900,
    fontSize: 12,
  },

  badgeCyan: {
    position: "absolute",
    top: 0,
    left: 0,
    padding: "5px 12px",
    borderRadius: "0 0 12px 0",
    background: "linear-gradient(90deg, #68ffff, #00d7ff)",
    color: "#00343b",
    fontWeight: 900,
    fontSize: 12,
  },

  chestWrap: {
    position: "relative",
    height: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  chest: {
    width: 70,
    height: 50,
    position: "relative",
    borderRadius: "17px 17px 10px 10px",
    background: "linear-gradient(180deg, #b86b26 0%, #8b4318 52%, #58260d 100%)",
    border: "3px solid #ffc342",
    boxShadow:
      "0 0 16px rgba(255,196,66,.45), 0 0 22px rgba(0,242,255,.16)",
    animation: "chestMove 2.4s ease-in-out infinite",
  },

  chestLid: {
    position: "absolute",
    left: -3,
    right: -3,
    top: -3,
    height: 23,
    borderRadius: "17px 17px 3px 3px",
    background: "linear-gradient(180deg, #d0802f, #9c4b18)",
    borderBottom: "3px solid rgba(80,35,10,.35)",
  },

  chestBandLeft: {
    position: "absolute",
    top: -3,
    bottom: -3,
    left: 14,
    width: 9,
    background: "linear-gradient(180deg, #ffd252, #ffb21b)",
    boxShadow: "0 0 8px rgba(255,195,66,.6)",
  },

  chestBandRight: {
    position: "absolute",
    top: -3,
    bottom: -3,
    right: 14,
    width: 9,
    background: "linear-gradient(180deg, #ffd252, #ffb21b)",
    boxShadow: "0 0 8px rgba(255,195,66,.6)",
  },

  chestLockRing: {
    position: "absolute",
    left: "50%",
    top: 18,
    width: 21,
    height: 21,
    borderRadius: "50%",
    border: "5px solid #4a210d",
    transform: "translateX(-50%)",
    zIndex: 2,
  },

  chestLock: {
    position: "absolute",
    left: "50%",
    top: 33,
    width: 20,
    height: 23,
    borderRadius: 6,
    background: "linear-gradient(180deg, #ffd252, #f5a90b)",
    transform: "translateX(-50%)",
    zIndex: 3,
    boxShadow: "0 0 8px rgba(255,210,82,.7)",
  },

  sparkOne: {
    position: "absolute",
    top: 4,
    left: 10,
    color: "#ffdf69",
    fontSize: 15,
    animation: "coinSpark 2.1s infinite",
  },

  sparkTwo: {
    position: "absolute",
    top: 8,
    right: 12,
    color: "#ffdf69",
    fontSize: 13,
    animation: "coinSpark 2.4s infinite .4s",
  },

  coinOne: {
    position: "absolute",
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#ffd24a",
    top: 24,
    left: 20,
    boxShadow: "0 0 8px #ffd24a",
    animation: "coinSpark 2.5s infinite .2s",
  },

  coinTwo: {
    position: "absolute",
    width: 7,
    height: 7,
    borderRadius: "50%",
    background: "#ffd24a",
    top: 30,
    right: 20,
    boxShadow: "0 0 8px #ffd24a",
    animation: "coinSpark 2.2s infinite .7s",
  },

  coinThree: {
    position: "absolute",
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#ffd24a",
    top: 14,
    right: 34,
    boxShadow: "0 0 8px #ffd24a",
    animation: "coinSpark 2.7s infinite 1s",
  },

  packInfo: {
    textAlign: "left",
    zIndex: 2,
  },

  coins: {
    fontSize: 28,
    lineHeight: 1,
    fontWeight: 900,
    color: "#fff",
    textShadow: "0 0 10px rgba(255,255,255,.30)",
  },

  coinLabel: {
    marginTop: 4,
    fontSize: 17,
    color: "rgba(255,255,255,.65)",
    fontWeight: 700,
  },

  sep: {
    width: 78,
    height: 1,
    margin: "9px 0",
    background: "linear-gradient(90deg, rgba(0,242,255,.65), transparent)",
  },

  price: {
    color: "#5ffaff",
    fontSize: 26,
    fontWeight: 900,
    textShadow: "0 0 14px rgba(0,242,255,.8)",
  },

  buyBtn: {
    gridColumn: "1 / 3",
    marginTop: 9,
    border: "1px solid rgba(95,250,255,.75)",
    borderRadius: 11,
    padding: "10px 14px",
    background: "linear-gradient(180deg, #18eaff, #0098d8)",
    color: "#001018",
    fontSize: 15,
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,.38)",
  },

  commissionBox: {
    maxWidth: 1080,
    margin: "28px auto 18px",
    padding: "26px 34px",
    borderRadius: 24,
    border: "1px solid rgba(0,242,255,.65)",
    background:
      "linear-gradient(90deg, rgba(0,242,255,.08), rgba(0,12,20,.88), rgba(0,242,255,.08))",
    boxShadow: "0 0 32px rgba(0,242,255,.2)",
    display: "grid",
    gridTemplateColumns: "150px 1fr 170px",
    alignItems: "center",
    gap: 24,
    textAlign: "left",
  },

  bigShield: {
    width: 110,
    height: 130,
    margin: "0 auto",
    borderRadius: "34px 34px 52px 52px",
    background: "linear-gradient(180deg, rgba(95,250,255,.9), rgba(0,95,130,.45))",
    border: "2px solid rgba(95,250,255,.85)",
    boxShadow: "0 0 28px rgba(0,242,255,.42)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#bfffff",
    fontSize: 54,
    fontWeight: 900,
  },

  commissionTextBox: {
    minWidth: 0,
  },

  commissionTitle: {
    margin: "0 0 10px",
    color: "#00f2ff",
    fontSize: 28,
    fontWeight: 900,
    letterSpacing: 1,
  },

  commissionText: {
    margin: "0 0 8px",
    color: "#fff",
    fontSize: 20,
    lineHeight: 1.45,
  },

  commissionSub: {
    margin: 0,
    color: "rgba(230,250,255,.76)",
    fontSize: 18,
    lineHeight: 1.4,
  },

  percentInline: {
    color: "#5ffaff",
    fontSize: 44,
    textShadow: "0 0 20px rgba(0,242,255,.8)",
  },

  percentCircle: {
    width: 140,
    height: 140,
    borderRadius: "50%",
    border: "16px solid rgba(0,242,255,.7)",
    boxShadow: "0 0 28px rgba(0,242,255,.45)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    animation: "percentPulse 2.5s infinite",
  },

  percentNumber: {
    fontSize: 42,
    fontWeight: 900,
    color: "#fff",
    lineHeight: 1,
  },

  percentSmall: {
    marginTop: 6,
    fontSize: 13,
    fontWeight: 900,
    color: "#d9fbff",
  },

  bottomInfo: {
    maxWidth: 980,
    margin: "0 auto",
    padding: "14px 18px",
    borderRadius: 22,
    border: "1px solid rgba(0,242,255,.25)",
    background: "rgba(0,12,20,.75)",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 10,
  },

  infoItem: {
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    fontSize: 16,
  },
};